import React from 'react';
import styled from 'styled-components';

interface StatisticProps {
  title: React.ReactNode;
  style?: React.CSSProperties;
}
const StatisticItem = styled.div`
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  border: solid 1px #dae5ec;
  font-size: 0.625rem;
  line-height: 1.4;
  letter-spacing: 0.5px;
  text-align: center;
  color: #4b6276;
  background-color: #f8f9fa;
  margin-bottom: 0.25rem;
  text-transform: uppercase;
  position: relative;
  white-space: nowrap;
`;
const JobStatistic = ({ title, style }: StatisticProps) => {
  return <StatisticItem style={style}>{title}</StatisticItem>;
};

export default JobStatistic;
